/* Large-lot mosaic: lightbox + Images/Description tab view. */
(function () {
  function initLightbox() {
    var mosaic = document.querySelector('[data-bhs-lotmosaic]');
    var lb = document.querySelector('[data-bhs-lotlb]');
    if (!mosaic || !lb) return;
    var tiles = Array.prototype.slice.call(mosaic.querySelectorAll('.bhs-lot__tile'));
    var fulls = tiles.map(function (t) { return t.getAttribute('data-full'); });
    var TOTAL = fulls.length, cur = 0;
    var img = lb.querySelector('[data-lbimg]');
    var count = lb.querySelector('[data-lbcount]');
    function setImg() {
      img.classList.remove('is-zoom'); img.style.transformOrigin = 'center';
      img.src = fulls[cur]; count.innerHTML = (cur + 1) + '<small>/' + TOTAL + '</small>';
    }
    function open(i) { cur = i; setImg(); lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }
    function close() { lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }
    function nav(d) { cur = (cur + d + TOTAL) % TOTAL; setImg(); }
    mosaic.addEventListener('click', function (e) { var t = e.target.closest('.bhs-lot__tile'); if (t) { e.preventDefault(); open(tiles.indexOf(t)); } });
    lb.addEventListener('click', function (e) {
      if (e.target.closest('[data-lbclose]')) { close(); return; }
      if (e.target.closest('[data-lbprev]')) { nav(-1); return; }
      if (e.target.closest('[data-lbnext]')) { nav(1); return; }
      if (e.target === img) { if (img.classList.contains('is-zoom')) { close(); } else { img.classList.add('is-zoom'); } return; }
      if (e.target.closest('[data-lbstage]')) { close(); }
    });
    img.addEventListener('mousemove', function (e) {
      if (!img.classList.contains('is-zoom')) return;
      var r = img.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
    });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') nav(-1);
      if (e.key === 'ArrowRight') nav(1);
    });
  }

  function initTabs() {
    var view = document.querySelector('[data-bhs-lotview]');
    if (!view) return;
    view.classList.add('js-on');
    var media = view.querySelector('[data-lotview-media]');
    var details = view.querySelector('[data-lotview-details]');
    var toggles = Array.prototype.slice.call(view.querySelectorAll('[data-lotview-toggle]'));
    function capImages() {
      if (!media || !details) return;
      if (view.classList.contains('is-desc')) media.style.maxHeight = Math.max(details.offsetHeight, 340) + 'px';
      else media.style.maxHeight = '';
    }
    function setDesc(on) {
      view.classList.toggle('is-desc', on);
      toggles.forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
      capImages();
      view.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    toggles.forEach(function (b) { b.addEventListener('click', function () { setDesc(!view.classList.contains('is-desc')); }); });
    window.addEventListener('resize', capImages);
  }

  function boot() { initLightbox(); initTabs(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
